import type { ReactNode } from 'react'
import { FuseGridBrandButton, type FuseGridBrandMarkVariant } from './FuseGridBrand'

function cx(...parts: Array<string | null | undefined | false>) {
  return parts.filter(Boolean).join(' ')
}

export function FuseGridSurfaceShell({
  title,
  subtitle,
  children,
  sidebar,
  actions,
  brand,
  brandHref,
  onBrandClick,
  brandMarkVariant = 'spark',
  topInsetPx = 0,
  className,
}: {
  title: ReactNode
  subtitle?: ReactNode
  children: ReactNode
  sidebar?: ReactNode
  actions?: ReactNode
  /** Optional brand node rendered in the titlebar in place of the default
   *  FuseGrid wordmark (e.g. the CFO Core lockup for admin surfaces). */
  brand?: ReactNode
  brandHref?: string
  onBrandClick?: () => void
  brandMarkVariant?: FuseGridBrandMarkVariant
  topInsetPx?: number
  className?: string
}) {
  return (
    <section
      className={cx('fg-surface-shell', className)}
      style={{ paddingTop: topInsetPx }}
      data-testid="fg-surface-shell"
    >
      <header className="fg-surface-titlebar">
        {brand ?? (
          <FuseGridBrandButton
            variant={brandMarkVariant}
            href={brandHref}
            onClick={onBrandClick}
            label="FuseGrid"
            subtitle="Workbook"
            title="Go to site home"
          />
        )}
        <div className="fg-surface-title-context">
          <div className="fg-surface-title">{title}</div>
          {subtitle ? <div className="fg-surface-subtitle">{subtitle}</div> : null}
        </div>
        <div className="fg-surface-title-spacer" />
        {actions ? <div className="fg-surface-actions">{actions}</div> : null}
      </header>
      <div className="fg-surface-body">
        {sidebar ? <div className="fg-surface-sidebar">{sidebar}</div> : null}
        <main className="fg-surface-main">
          {children}
        </main>
      </div>
    </section>
  )
}
